import { c as _c } from "react/compiler-runtime";
import type { AuditEvent } from '@onefootprint/request-types/dashboard';
import { Divider, SearchInput, Toggle } from '@onefootprint/ui';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '@/components/section-header';
import { MAIN_PAGE_ID } from '@/config/constants';
import useGetAccessEvents from '@/hooks/use-get-access-events';
import useSecurityLogsQueryParams from '@/hooks/use-security-logs-filters';
import useSession from '@/hooks/use-session';
import Filters from './components/filters';
import Timeline from './components/timeline';
const SecurityLogs = () => {
  const $ = _c(56);
  const {
    t
  } = useTranslation("security-logs");
  const [showDecryptionReason, setShowDecryptionReason] = useState(false);
  const {
    data: session
  } = useSession();
  const getAccessEvents = useGetAccessEvents();
  const queryParams = useSecurityLogsQueryParams();
  const auditEvents = getAccessEvents.data?.pages.reduce(_temp, []) ?? [];
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["decrypt_user_data", "create_org_role", "update_org_role", "deactivate_org_role", "invite_org_member", "update_org_member", "remove_org_member", "decrypt_org_api_key", "update_org_api_key_status", "create_org_api_key", "update_org_api_key_role", "update_user_data", "delete_user_data", "manually_review_entity"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const accessEventsToShow = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [...accessEventsToShow, "create_playbook", "edit_playbook", "copy_playbook", "update_playbook_status"];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const extendedAccessEventsToShow = t1;
  const isFirmEmployee = session?.user?.isFirmEmployee;
  let t2;
  let t3;
  if ($[2] !== getAccessEvents) {
    t2 = () => {
      const checkIfShouldLoadMore = () => {
        const mainContainer = document.getElementById(MAIN_PAGE_ID);
        if (!mainContainer) {
          return;
        }
        const {
          scrollHeight,
          clientHeight
        } = mainContainer;
        const shouldLoadMore = scrollHeight <= clientHeight;
        if (shouldLoadMore && !getAccessEvents.isFetchingNextPage && getAccessEvents.hasNextPage) {
          getAccessEvents.fetchNextPage();
        }
      };
      const handleScroll = () => {
        const mainContainer_0 = document.getElementById(MAIN_PAGE_ID);
        if (!mainContainer_0) {
          return;
        }
        const {
          scrollHeight: scrollHeight_0,
          scrollTop,
          clientHeight: clientHeight_0
        } = mainContainer_0;
        const offset = clientHeight_0 * 0.5;
        const reachedBottom = scrollHeight_0 - scrollTop <= clientHeight_0 + offset;
        if (reachedBottom && !getAccessEvents.isFetchingNextPage && getAccessEvents.hasNextPage) {
          getAccessEvents.fetchNextPage();
        }
      };
      checkIfShouldLoadMore();
      const mainContainer_1 = document.getElementById(MAIN_PAGE_ID);
      mainContainer_1?.addEventListener("scroll", handleScroll);
      return () => mainContainer_1?.removeEventListener("scroll", handleScroll);
    };
    t3 = [getAccessEvents, getAccessEvents.data];
    $[2] = getAccessEvents;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== isFirmEmployee) {
    t4 = auditEvent => isFirmEmployee ? extendedAccessEventsToShow.includes(auditEvent.detail.kind) : accessEventsToShow.includes(auditEvent.detail.kind);
    $[5] = isFirmEmployee;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const filteredAuditEvents = auditEvents.filter(t4);
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp2);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <Head><title>{t5}</title></Head>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp3);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <header className="hidden md:flex items-center justify-between mb-6"><h2 className="text-heading-2">{t7}</h2></header>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t(_temp4);
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t(_temp5);
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <SectionHeader title={t9} subtitle={t10} />;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Divider className="mb-4" />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== queryParams) {
    t13 = value => queryParams.push({
      search: value
    });
    $[23] = queryParams;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = queryParams.values.search || "";
  let t15;
  if ($[25] !== t) {
    t15 = t(_temp6);
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t14 || $[29] !== t15) {
    t16 = <SearchInput width="100%" containerClassName="max-md:min-w-0 flex-1 md:w-[232px] md:flex-none" onChangeText={t13} value={t14} size="compact" shape="pill" placeholder={t15} />;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Filters />;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t16) {
    t18 = <div className="flex flex-row gap-3">{t16}{t17}</div>;
    $[32] = t16;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = checked => setShowDecryptionReason(checked);
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t) {
    t20 = t(_temp7);
    $[35] = t;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== showDecryptionReason || $[38] !== t20) {
    t21 = <div><Toggle checked={showDecryptionReason} onChange={t19} size="compact" label={t20} /></div>;
    $[37] = showDecryptionReason;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t18 || $[41] !== t21) {
    t22 = <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between md:gap-0">{t18}{t21}</div>;
    $[40] = t18;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== filteredAuditEvents || $[44] !== getAccessEvents.isError || $[45] !== getAccessEvents.isLoading || $[46] !== showDecryptionReason) {
    t23 = <Timeline isError={getAccessEvents.isError} auditEvents={filteredAuditEvents} isLoading={getAccessEvents.isLoading} showDecryptionReason={showDecryptionReason} />;
    $[43] = filteredAuditEvents;
    $[44] = getAccessEvents.isError;
    $[45] = getAccessEvents.isLoading;
    $[46] = showDecryptionReason;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t22 || $[49] !== t23) {
    t24 = <div className="flex flex-col gap-8">{t22}{t23}</div>;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t11 || $[52] !== t24 || $[53] !== t6 || $[54] !== t8) {
    t25 = <>{t6}{t8}{t11}{t12}{t24}</>;
    $[51] = t11;
    $[52] = t24;
    $[53] = t6;
    $[54] = t8;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  return t25;
};
export default SecurityLogs;
function _temp(allPages, page) {
  return [...allPages, ...(page?.data ?? [])];
}
function _temp2($) {
  return $.pageTitle;
}
function _temp3($_0) {
  return $_0.metaTitle;
}
function _temp4($_1) {
  return $_1.header.title;
}
function _temp5($_2) {
  return $_2.header.subtitle;
}
function _temp6($_3) {
  return $_3.filters.search;
}
function _temp7($_4) {
  return $_4.showDecryptionReason;
}